const env = n => (window.env || {})[n] || process.env[n];

const API_BASE = env('REACT_APP_API_BASE');
const API_USERNAME = env('REACT_APP_API_USERNAME');
const API_PASSWORD = env('REACT_APP_API_PASSWORD');
const buff = btoa(`${API_USERNAME}:${API_PASSWORD}`);

export { API_BASE, buff };
